module.exports = __webpack_public_path__ + "static/img/hb.f3b5f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hb.png
// module id = 5MDl
// module chunks = 1